import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { useDispatch } from 'react-redux';
import { propShape } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import { useClientSeminarRequestConfirm } from '../../../helpers/use/client_seminar/useClientSeminarForm';
import { useUnmountRef } from '../../../helpers/use/useHook';
import Layout from '../../Layout';
import Breadcrumb from '../../Layout/Breadcrumb';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import ClientSeminarOneConfirmHoc from './Hoc/ClientSeminarOneConfirmHoc';
import SeminarOneRequestFormConfirm from './Parts/SeminarOneForm/SeminarOneRequestFormConfirm';
import SeminarOneSkeleton from './Parts/SeminarOneSkeleton';
import SeminarOneSticky from './Parts/SeminarOneSticky';
import SeminarOneTitle from './Parts/SeminarOneTitle';
/**
 * セミナー申し込み確認ページ
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneConfirm = (props) => {
    const { seminar, values } = props;
    const { id, information: { title }, } = seminar;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const pans = useMemo(() => [
        {
            link: '/seminar',
            text: 'セミナー',
        },
        {
            link: `/seminar/${id}/request`,
            text: title,
        },
        {
            link: '',
            text: '申し込み内容の確認',
        },
    ], [id, title]);
    const { loading, onSubmit } = useClientSeminarRequestConfirm({
        dispatch,
        seminar,
        unmountRef,
        values,
    });
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main client_seminar_one', sticky: _jsx(SeminarOneSticky, { id: id, loading: loading, onSubmit: onSubmit }) }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(SeminarOneTitle, { seminar: seminar }), _jsx("div", Object.assign({ className: 'seminar_container' }, { children: _jsx(SeminarOneRequestFormConfirm, { values: values }) }))] })));
};
SeminarOneConfirm.propTypes = {
    seminar: propShape().isRequired,
    values: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isNotRequireCheckProfile: true,
    isProfessional: false,
}), ClientSeminarOneConfirmHoc({}, SeminarOneSkeleton));
export default enhance(SeminarOneConfirm);
